import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ThemeProvider} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import {createAdminTheme, createTvTheme} from "./theme";
import {useLocation} from "react-router-dom";
import {BrowserRouter} from "react-router-dom";
import {AppContainerProvider} from "./app/composition/container";
import {useMemo} from "react";
import {useAppSettings} from "./settings/appSettings";

const ThemeWrapper: React.FC = () => {
    const location = useLocation();
    const settings = useAppSettings();
    const isTvRoute = location.pathname.startsWith("/numbers");
    const primary = settings.theme.primary;
    const secondary = settings.theme.secondary;
    const backgroundFrom = settings.theme.backgroundFrom;
    const backgroundTo = settings.theme.backgroundTo;
    const theme = useMemo(() => {
        const themeSettings = {theme: {primary, secondary, backgroundFrom, backgroundTo}};
        return isTvRoute ? createTvTheme(themeSettings) : createAdminTheme(themeSettings);
    }, [isTvRoute, primary, secondary, backgroundFrom, backgroundTo]);
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline/>
            <App/>
        </ThemeProvider>
    );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <BrowserRouter>
          <AppContainerProvider>
              <ThemeWrapper/>
          </AppContainerProvider>
      </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
